import { Button } from "@calcom/ui";
import QuickBooking from "../../bookings/components/QuickBooking";
import type { getBookingPropsForExpersIds } from "../lib/getBookingPropsForExpersIds";
import type { getExperts } from "experts/lib/getExperts";
import Link from "next/link";
import NextAvailableSlot from "../../bookings/components/NextAvailableSlot";
import NextImage from "next/image";

type ExpertCardProps = {
  expert: Awaited<ReturnType<typeof getExperts>>[0];
  booking: Awaited<ReturnType<typeof getBookingPropsForExpersIds>> | null;
  nextAvailableSlot: string | null;
};

export function ExpertCard({ expert, booking, nextAvailableSlot }: ExpertCardProps) {
  return (
    <article key={expert.id} className="border-brand-100 flex flex-col border">
      <header className="bg-brand-50 relative flex w-full items-end justify-start">
        <div className="flex w-full flex-col items-start justify-end p-6">
          <h2 className="text-2xl lg:text-4xl">{expert.name}</h2>
          <p className="text-lg">{expert.position}</p>
        </div>
        <NextImage
          // @ts-expect-error contentful types are wrong
          src={expert.picture?.fields?.file?.url || ""}
          alt={`Photo of ${expert.name ?? "the expert"}`}
          width={300}
          height={300}
          sizes="(max-width: 768px) 100w, (max-width: 1200px) 200w, 300w"
          className="aspect-square h-44 object-cover lg:mr-6 xl:h-[300px]"
        />
        <Link href={`/consultations/expert/${expert.username}`} className="sr-only absolute inset-0">
          {`Learn more about ${expert.username}`}
        </Link>
      </header>
      <p className="p-6 text-xl leading-relaxed">{expert.bio}</p>
      <p className="px-6 pb-6 text-xl leading-relaxed">
        Running time: 60 minutes
        <br />
        Price: <span className="line-through">£120</span>{" "}
        <span className="font-bold">NOW FREE (limited time offer)</span>
      </p>
      <footer className="mt-auto grid w-full grid-cols-1 gap-6 p-6 pt-0 md:grid-cols-2">
        <NextAvailableSlot nextAvailableSlot={nextAvailableSlot} />
        <Button color="secondary" size="2xl" href={`/consultations/expert/${expert.username}`}>
          Learn more
          <span className="sr-only">{`about ${expert.username}`}</span>
        </Button>
        <QuickBooking size="2xl" booking={booking} userList={[expert.username]} />
      </footer>
    </article>
  );
}
